"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreenCanvasView = exports.LoadingView = void 0;
const native_1 = __importDefault(require("styled-components/native"));
const react_native_1 = require("react-native");
const LoadingView = native_1.default(react_native_1.Animated.View).attrs(({ size, thickness, color, spinningColor, }) => ({
    size: size || 18,
    thickness: thickness || 2,
    color,
    spinningColor: spinningColor || 'transparent',
})) `
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border: ${({ thickness }) => thickness}px solid
    ${({ theme, color }) => color || theme.bpCore.colors.loadingSpinnerColor};
  border-bottom-color: ${({ spinningColor }) => spinningColor};
  border-radius: ${({ size }) => Math.round(size / 2)}px;
  background: transparent;
`;
exports.LoadingView = LoadingView;
const FullScreenCanvasView = native_1.default.View `
  width: 100%;
  height: 100%;
  z-index: 999;
  position: absolute;
  align-items: center;
  flex: 1;
  justify-content: center;
`;
exports.FullScreenCanvasView = FullScreenCanvasView;
